<template>
    <!-- 购物车页面主容器 -->
    <div class="cart-container">
        <!-- 工具栏：全选和批量删除按钮 -->
        <div class="cart-toolbar">
            <el-checkbox v-model="allChecked" @change="toggleAll">全选</el-checkbox>
            <el-button type="danger" size="mini" @click="batchDelete">删除</el-button>
        </div>
        <!-- 循环渲染每个店铺及其商品 -->
        <div v-for="(shop, sIdx) in cartData" :key="shop.shop" class="shop-block">
            <!-- 店铺选择框和进店按钮 -->
            <el-checkbox v-model="shop.checked" @change="toggleShop(sIdx, shop.checked)">
                {{ shop.shopName }}
            </el-checkbox>
            <el-button size="mini" class="shop-btn" @click="goToShop(shop.shopId)">进店</el-button>
            <!-- 商品表格 -->
            <el-table :data="shop.cartItemList" border :show-header="false">
                <!-- 商品选择框 -->
                <el-table-column width="55">
                    <template v-slot="{ row }">
                        <el-checkbox v-model="row.checked" @change="toggleProduct(sIdx)"></el-checkbox>
                    </template>
                </el-table-column>
                <!-- 商品名称 -->
                <el-table-column prop="goodsName" label="商品"></el-table-column>
                <!-- 商品规格 -->
                <el-table-column prop="specification" label="规格">
                    <template v-slot="{ row }">
                        <span class="spec">{{ row.specification }}</span>
                    </template>
                </el-table-column>
                <!-- 商品数量，可编辑 -->
                <el-table-column label="数量">
                    <!--    :increase-disabled="row.isValid !== 1" :decrease-disabled="row.num <= 1" -->
                    <template v-slot="{ row }">
                        <!-- {{ row.num }} -->
                        <el-input-number v-model="row.num" :min="1" size="small" @change="onNumChange(row)" />
                    </template>
                </el-table-column>
                <!-- 小计，含邮费提示 -->
                <el-table-column label="小计">
                    <template v-slot="{ row }">
                        <span class="subtotal">
                            ￥{{ ((row.productPrice * row.num) + (row.mailFlag !== 1 ? row.num * (row.mailPrice || 0) :
                            0)).toFixed(2) }}
                            <span v-if="row.mailFlag !== 1" style="color:#888;font-size:12px;">(含邮费{{ (row.num *
                                (row.mailPrice || 0)).toFixed(2) }})</span>
                        </span>
                    </template>
                </el-table-column>
                <!-- 删除商品按钮 -->
                <el-table-column label="操作">
                    <template v-slot="{ row }">
                        <el-button type="text" @click="delShop(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 购物车结算信息 -->
        <div class="cart-summary">
            <div>
                收货地址：
                <template v-if="displayAddress">
                    {{ displayAddress.userName }},{{ displayAddress.phone }},{{ displayAddress.address }}
                    <el-link type="primary" @click="editAddress('edit')">修改>></el-link>
                </template>
                <template v-else>
                    <el-link type="primary" @click="editAddress('add')">新增</el-link>
                </template>
            </div>
            <div class="cart-total">
                合计：<span class="total-price">￥{{ totalPrice.toFixed(2) }}</span>
                <span class="shipping">(含邮费{{ shipping.toFixed(2) }}元)</span>
                <el-button type="success" @click="checkout()">去支付</el-button>
            </div>
        </div>
        <!-- 修改地址弹窗 -->
        <editAddressDialog :visible.sync="editAddressDialogVisible" :mySelfAddress.sync="mySelfAddress" @select="handleSelectAddress" />
        <!-- 新增地址弹窗 -->
        <addAddress :visible.sync="addAddressDialogVisible" @save="handleAddAddress" />
    </div>
</template>

<script>
// 引入API方法和子组件
import { shopList, addressList, shopDelete, updateProductNum, orderSubmit, cartOrder } from '@/api/sjzx'
import editAddressDialog from '../components/editAddressDialog.vue';
import addAddress from '../components/addAddress.vue';

export default {
    data() {
        return {
            // 购物车数据
            cartData: [],
            // 控制编辑地址弹窗显示
            editAddressDialogVisible: false,
            // 收货地址列表
            mySelfAddress: [],
            // 控制新增地址弹窗显示
            addAddressDialogVisible: false,
            // 当前选中的收货地址
            selectedAddress: null,
        };
    },
    computed: {
        // 计算所有选中商品的总邮费
        shipping() {
            let total = 0;
            this.cartData.forEach(shop => {
                shop.cartItemList.forEach(item => {
                    // 只统计选中且 mailFlag 不为 1 的商品邮费
                    if (item.checked && item.mailFlag !== 1) {
                        total += item.num * (item.mailPrice || 0);
                    }
                });
            });
            return total;
        },
        // 计算所有选中商品的总价（含邮费）
        totalPrice() {
            return this.cartData.reduce((sum, shop) => {
                return sum + shop.cartItemList
                    .filter(item => item.checked)
                    .reduce((shopSum, item) => shopSum + item.productPrice * item.num, 0);
            }, 0) + this.shipping;
        },
        // 全选/全不选控制
        allChecked: {
            get() {
                return Array.isArray(this.cartData) && this.cartData.length > 0
                    ? this.cartData.every(shop => shop.checked)
                    : false;
            },
            set(val) {
                if (Array.isArray(this.cartData)) {
                    this.cartData.forEach(shop => {
                        this.$set(shop, 'checked', val);
                        shop.cartItemList.forEach(p => this.$set(p, 'checked', val));
                    });
                }
            }
        },
        // 当前显示的收货地址
        displayAddress() {
            if (this.selectedAddress) return this.selectedAddress;
            return this.mySelfAddress.find(addr => addr.defaultFlag === '1') || this.mySelfAddress[0] || null;
        }
    },
    components: { editAddressDialog, addAddress },
    mounted() {
        // 页面加载时获取购物车和地址信息
        this.getCartList()
        this.getAddressInfo()

    },
    methods: {

        // 切换全选
        toggleAll(val) {
            this.allChecked = val;
        },
        // 切换店铺下所有商品的选中状态
        toggleShop(sIdx, val) {
            const shop = this.cartData[sIdx];
            shop.cartItemList.forEach(p => this.$set(p, 'checked', val));
            this.$set(shop, 'checked', val);
        },
        // 切换单个商品选中状态后，判断店铺是否全选
        toggleProduct(sIdx) {
            const shop = this.cartData[sIdx];
            this.$set(shop, 'checked', shop.cartItemList.every(p => p.checked));
        },
        // 编辑/新增地址弹窗
        editAddress(mode) {
            if (mode === 'edit') {
                this.editAddressDialogVisible = true;
            } else if (mode === 'add') {
                this.addAddressDialogVisible = true;
            }
        },
        // 新增地址后刷新地址列表
        handleAddAddress() {
            this.getAddressInfo()
        },
        // 去结算（下单）
        async checkout() {
            // 收集所有选中商品的id
            const ids = [];
            this.cartData.forEach(shop => {
                shop.cartItemList.forEach(item => {
                    if (item.checked) {
                        ids.push(item.id);
                    }
                });
            });
            if (ids.length == 0) {
                this.$message.warning('请先选择要下单的商品');
                return;
            }
            // 组装下单参数
            let params = {
                addressId: this.displayAddress.id,
                cartIds: ids
            }
            let res = await cartOrder(params)
            if (res.code == 0) {
                // 下单成功跳转到订单成功页
                this.$router.push({
                    name: 'OrderSubmitSuccess', query: {
                        orderId: res.data.order.id,
                        totalPrice: res.data.order.totalPrice,
                        orderType: '0'
                    }
                })
            }
        },
        // 跳转到店铺页面
        goToShop(shopId) {
            // console.log(shopName,'查看获取到的值')
            // this.$router.push({
            //     path: '/quickLink/agriService'
            // })
            this.$router.push({
              path: '/quickLink/agriServiceShop', query: { shopId: shopId }
                 })
        },
        // 获取购物车列表
        async getCartList() {
            try {
                const res = await shopList();
                this.cartData = Array.isArray(res.data.cartList) ? res.data.cartList : [];
                // 初始化店铺选中状态
                this.cartData.forEach(shop => {
                    this.$set(shop, 'checked', shop.cartItemList.every(item => item.checked));
                });
            } catch (e) {
                this.$message.error('获取购物车失败');
            }
        },
        // 选择收货地址
        handleSelectAddress(address) {
            this.selectedAddress = address;
        },
        // 获取收货地址信息
        async getAddressInfo() {
            try {
                const res = await addressList();
                this.mySelfAddress = res.data.records || [];
                if (!this.selectedAddress) {
                    this.selectedAddress = this.mySelfAddress.find(addr => addr.defaultFlag === '1') || this.mySelfAddress[0] || null;
                }
            } catch (e) {
                this.$message.error('获取地址失败');
            }
        },
        // 删除单个商品
        async delShop(row) {
            this.$confirm('确定要删除商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // 调用删除接口
                await shopDelete({ ids: [row.id].join(',') });
                this.getCartList();
                this.$message.success('删除成功');
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        // 批量删除选中商品
        batchDelete() {
            this.$confirm('确定要删除选中的商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // 收集所有选中商品的id
                const ids = [];
                this.cartData.forEach(shop => {
                    shop.cartItemList.forEach(item => {
                        if (item.checked) {
                            ids.push(item.id);
                        }
                    });
                });
                if (ids.length == 0) {
                    this.$message.warning('请先选择要删除的商品');
                    return;
                }
                // 调用批量删除接口
                await shopDelete({ ids: ids.join(',') });
                if (res.code == 0) {
                    this.getCartList();
                    this.$message.success('删除成功');
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        // 商品数量变更
        async onNumChange(row) {
            // 数量变更后同步到后端
            let res = await updateProductNum({
                num: row.num, cartId: row.id
            })
            // if (res.code == 0) {
            //     this.getCartList()
            // }
        },
    },
};
</script>

<style scoped>
/* 购物车页面样式 */
.cart-container {
    background: #fafbfc;
    padding: 30px;
}

.cart-summary {
    background: #fff;
    padding: 20px;
    margin-top: 20px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.cart-total {
    margin-top: 10px;
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    gap: 20px;
}

.total-price {
    color: #f00;
    font-weight: bold;
    font-size: 22px;
}

.shipping {
    color: #f00;
    font-size: 16px;
}

.shop-btn {
    margin-left: 10px;
    background: #fff;
    color: #666;
    border: 1px solid #ccc;
}

.spec {
    color: #888;
}

.subtotal {
    color: #f00;
    font-weight: bold;
}

.cart-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}
</style>
